import React from 'react';
import Skeleton from 'react-loading-skeleton';
import ExpandedText from '../../../../../common/helpers/expanded_text';
import ReadingSinceAndCountItem, { readingSinceAndCountItemThemes } from '../../../advisor/nested_views/readingSinceAndCountItem';
import classes from './classes.module.scss';
import { skeletonOrItem } from '../nested_views_utils';
import { isMobile } from '../../../../config/util';
import PriceText from '../price_text';

const maxServiceDescriptionChars = 100;

const getServiceDescriptionRowsCount = () => {
  if (isMobile()) return 3;
  return 4;
};

export function AdvisorPreviewService({
  advisor,
  loading
}) {
  if (!advisor) return null;

  return (
    <div className={ classes.advisrServiceContainer }>
      <div className={ classes.advisrService }>
        <ReadingSinceAndCountItem
          readingsCount={ advisor.readingsCount }
          yearJoined={ advisor.yearJoined }
          theme={ readingSinceAndCountItemThemes.onHomePageSecriceContainer }
          loading={ loading }
          isNewAdvisor={ advisor.isNewAdvisor }
        />
        <div className={ classes.advisornickNameAndServiceContainer }>
          <ExpandedText ellipsis className={ classes.advisorNickNameContainer }>
            <span className={ classes.advisrNickName } suppressHydrationWarning>
              {skeletonOrItem({ item: advisor.nickname, skeletonWidth: 170 })}
            </span>
          </ExpandedText>
          <ExpandedText ellipsis className={ classes.advisorServiceTitleContainer }>
            <span className={ classes.advisorServiceTitle } suppressHydrationWarning>
              {skeletonOrItem({ item: advisor.serviceTitle, skeletonWidth: 170 })}
            </span>
          </ExpandedText>
        </div>
        <ExpandedText
          ellipsis
          className={ classes.serviceDescriptionContainer }
          limit={ getServiceDescriptionRowsCount() }
          textStyle={ { lineHeight: '14px' } }
        >
          <span className={ classes.advisrServiceText } suppressHydrationWarning>
            {skeletonOrItem({ item: advisor.serviceDescription, skeletonWidth: 170, maxChars: maxServiceDescriptionChars })}
          </span>
        </ExpandedText>
      </div>
    </div>
  );
}

export function PsiquicosAdvisorPreviewService({
  advisor,
  loading,
  t,
  freeMinutesBadge = null
}) {
  if (!advisor) return null;

  return (
    <div className={ classes.advisrServiceContainer }>
      <div className={ `${ classes.advisrService } ${ classes.psiquicosAdvisorService }` }>
        <div className={ classes.psiquicosMobileNameBlock }>
          <ExpandedText ellipsis className={ classes.psiquicosNickNameWrap }>
            <span className={ classes.psiquicosNickName } suppressHydrationWarning>
              {skeletonOrItem({ item: advisor.nickname, skeletonWidth: 170 })}
            </span>
          </ExpandedText>
          <ExpandedText ellipsis className={ classes.psiquicosServiceTitleWrap }>
            <span className={ classes.psiquicosServiceTitle } suppressHydrationWarning>
              {skeletonOrItem({ item: advisor.serviceTitle, skeletonWidth: 170 })}
            </span>
          </ExpandedText>
        </div>
        <div className={ classes.psiquicosDescriptionGroup }>
          <ExpandedText
            ellipsis
            className={ classes.psiquicosDescriptionContainer }
            limit={ getServiceDescriptionRowsCount() }
            customClasses={ { text: classes.psiquicosDescriptionText, readMoreBtn: '' } }
            textStyle={ {
              whiteSpace: 'normal',
              lineHeight: isMobile() ? '14px' : '20px'
            } }
          >
            {skeletonOrItem({ item: advisor.serviceDescription, skeletonWidth: 170 })}
          </ExpandedText>
          <div className={ classes.psiquicosPriceRow }>
            {loading ? <Skeleton height={ 48 } /> : (
              <PriceText { ...advisor } text={ t('home_page.from') } stacked />
            )}
          </div>
        </div>
        <div className={ classes.psiquicosReadingsAndFreeMinRow }>
          <div className={ classes.psiquicosReadingsColumn }>
            {loading ? <Skeleton height={ 40 } className={ classes.psiquicosReadingsSkeleton } /> : (
              <ReadingSinceAndCountItem
                readingsCount={ advisor.readingsCount }
                yearJoined={ advisor.yearJoined }
                isNewAdvisor={ advisor.isNewAdvisor }
                theme={ readingSinceAndCountItemThemes.onHomePagePsiquicosServiceContainer }
                loading={ false }
                plain
              />
            )}
          </div>
          { freeMinutesBadge ? (
            <div className={ classes.psiquicosFreeMinWrap }>
              { freeMinutesBadge }
            </div>
          ) : null }
        </div>
      </div>
    </div>
  );
}
